import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiDoubleYpsili';
const args = {};

export class PetastiDoubleYpsili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
